import React, { useState } from "react"
import PropTypes from "prop-types"
import PrimaryButton from "../../../components/molecules/buttons/PrimaryButton.molecule"
import PencilFillIcon from "../../../design/assests/images/icons/pencil-fill"
import useThemeContext from "../../../hooks/contextConsumers/useThemeContext.hook"

export const EDITABLE_ELEMENT_BTN_TYPES = {
  TRANSPARENT: "transparent",
  PRIMARY: "primary",
}
const EditableElement = ({
  placeholderTemplate,
  placeholderClassName = "",
  onEditTemplate,
  onEdit,
  btnType = EDITABLE_ELEMENT_BTN_TYPES.TRANSPARENT,
  disableBtn = false,
  readOnly = false,
}) => {
  const [editing, setEditing] = useState(false)
  const { theme } = useThemeContext()
  const controlledOnEdit = () => {
    setEditing(true)
    onEdit && onEdit()
  }
  if (editing && onEditTemplate) {
    return onEditTemplate({
      onClose: () => setEditing(false),
      onBlur: () => setEditing(false),
    })
  }
  const renderButton = () => {
    if (btnType === EDITABLE_ELEMENT_BTN_TYPES.TRANSPARENT) {
      return (
        <i
          className="pi pi-pencil cursor-pointer"
          style={{
            color:
              "light-dark(var(--primary-color-highlight), var(--clr-info))",
          }}
          onClick={controlledOnEdit}
          disabled={disableBtn}
        />
      )
    }
    if (btnType === EDITABLE_ELEMENT_BTN_TYPES.PRIMARY) {
      return (
        <PrimaryButton
          className="w-2rem h-2rem"
          onClick={controlledOnEdit}
          icon={theme === "dark" ? <PencilFillIcon /> : "pi pi-pencil"}
          rounded
          disabled={disableBtn}
        />
      )
    }
  }
  return (
    <div className="flex align-items-center gap-2">
      <span className={`font-semibold text-xl ${placeholderClassName}`}>
        {placeholderTemplate}
      </span>
      {!readOnly && renderButton()}
    </div>
  )
}

export default EditableElement

EditableElement.propTypes = {
  placeholderTemplate: PropTypes.node,
  onEditTemplate: PropTypes.func,
  onEdit: PropTypes.func,
  onBlur: PropTypes.func,
}
